// extracted by mini-css-extract-plugin
module.exports = {"download-declaration-modal":"DownloadDeclarationModal__download-declaration-modal--cxuB3","loading":"DownloadDeclarationModal__loading--3_bU-"};